exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-button--danger[data-v-4e1389f0] {\n  margin-right: 11%;\n  color: #FFF;\n  background-color: #F56C6C;\n  border-color: #F56C6C;\n}\n.custom_button[data-v-4e1389f0] {\n  display: flex;\n  justify-content: right;\n}\n", ""]);

// exports
